export const SET_CALENDAR = "SET_CALENDAR";
export const SET_CALENDARS = "SET_CALENDARS";
export const ADD_CALENDAR = "ADD_CALENDAR";
export const UPDATE_CALENDAR = "UPDATE_CALENDAR";
export const SET_CALENDAR_SELECTED = "SET_CALENDAR_SELECTED";
